import { makeStyles } from '@material-ui/core/styles';
import { Button, ExtLink } from '@/components/global';
import Card from './Card';

const useStyles = makeStyles(({ breakpoints: BP }) => ({
  card: {
    display: 'flex',
    flexDirection: 'column',
    margin: '50px 10%',
    borderRadius: 10,
    boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
    backgroundColor: '#fff',
    color: '#283142',
    boxSizing: 'border-box',
    padding: '50px 40px',
    [BP.between('xs', 'md')]: {
      padding: '7% 0',
      margin: '35px 5% 35px 0',
      borderRadius: '0 10px 10px 0',
    },
  },

  header: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    '& h1': {
      fontSize: 30,
      margin: 0,
    },
    marginBottom: 40,

    [BP.between('xs', 'md')]: {
      margin: '0 20px 20px',
      '& h1': {
        fontSize: 20,
      },
      '& button': {
        fontSize: 15,
        padding: '10px 10px',
        borderRadius: 10,
      },
    },
  },
  row: {
    display: 'flex',
    justifyContent: 'space-between',

    [BP.between('xs', 'md')]: {
      overflow: 'scroll',
      marginLeft: 20,
      padding: '10px 0',
    },
  },
}));

export default function Blog({ DATA = [] }) {
  const cls = useStyles();
  return (
    <section className={cls.card}>
      <div className={cls.header}>
        <h1>تازه ترین های مجله</h1>
        <ExtLink href="https://decooj.com/magazine">
          <Button>مطالعه بیشتر</Button>
        </ExtLink>
      </div>
      <div className={cls.row}>
        {DATA.map((i, idx) => (
          <Card item={i} key={idx} />
        ))}
      </div>
    </section>
  );
}
